<!-- Data Table -->
<p-table 
    #dt
    [value]="codes" 
    [loading]="isLoading"
    [paginator]="true" 
    [rows]="amountOfRows"
    [totalRecords]="totalRecords"
    [lazy]="true"
    (onLazyLoad)="onLazyLoad($event)"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first}-{last} of {totalRecords} items"
    [rowsPerPageOptions]="[5, 10, 25, 50]"
    [alwaysShowPaginator]="true"
    [resetPageOnSort]="true"
    [sortOrder]="defaultSortOrderOnLoad"
    [defaultSortOrder]="defaultSortOrder"
    [sortField]="defaultSortField"
    class="table-parameters table-paginator"
    dataKey="code"
    [expandedRowKeys]="expandedRowKeys">
    
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th class="w-12"><span class="sr-only">Expand</span></th>
        <th pSortableColumn="code">
          <div class="flex items-center gap-2">
            Code
            <p-sortIcon 
              [ariaLabelDesc]="'Activate to sort in descending order'"
              [ariaLabelAsc]="'Activate to sort in ascending order'"
              field="code">
            </p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="shortDescription">
          <div class="flex items-center gap-2">
            Short Description
            <p-sortIcon 
              [ariaLabelDesc]="'Activate to sort in descending order'"
              [ariaLabelAsc]="'Activate to sort in ascending order'"
              field="shortDescription">
            </p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="planEffectiveStartDate">
          <div class="flex items-center gap-2">
            Plan Effective Start Date
            <p-sortIcon 
              [ariaLabelDesc]="'Activate to sort in descending order'"
              [ariaLabelAsc]="'Activate to sort in ascending order'"
              field="planEffectiveStartDate">
            </p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="planEffectiveEndDate">
          <div class="flex items-center gap-2">
            Plan Effective End Date
            <p-sortIcon 
              [ariaLabelDesc]="'Activate to sort in descending order'"
              [ariaLabelAsc]="'Activate to sort in ascending order'"
              field="planEffectiveEndDate">
            </p-sortIcon>
          </div>
        </th>
        <th>
          <div class="flex items-center gap-2">
            DMEPOS Category
          </div>
        </th>
        <th pSortableColumn="modifiers">
          <div class="flex items-center gap-2">
            Modifier(s)
            <p-sortIcon 
              [ariaLabelDesc]="'Activate to sort in descending order'"
              [ariaLabelAsc]="'Activate to sort in ascending order'"
              field="modifiers">
            </p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="forms" class="text-right">
          <div class="flex items-center gap-2 justify-end">
            Forms
            <p-sortIcon 
              [ariaLabelDesc]="'Activate to sort in descending order'"
              [ariaLabelAsc]="'Activate to sort in ascending order'"
              field="forms">
            </p-sortIcon>
          </div>
        </th>
        <th style="width: 30px"><span class="sr-only">Actions</span></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-code let-expanded="expanded">
      <tr [ngClass]="{'row-expanded': expanded, ...getRowClass(code)}">
        <td class="py-0! w-12">
          <button
            type="button"
            pButton
            class="transition-transform! duration-300"
            icon="pi pi-chevron-right"
            [rounded]="true"
            [text]="true"
            (click)="toggleRow(code.code)"
            [class]="{ 'rotate-90': expanded }"
            [attr.aria-label]="expanded ? 'Collapse row for code ' + code.code : 'Expand row for code ' + code.code"
            [attr.aria-expanded]="expanded"
          ></button>
        </td>
        <td>{{ code.code }}</td>
        <td>{{ code.shortDescription }}</td>
        <td>
          <div class="flex items-center gap-2">
            <span>{{ (code.planEffectiveStartDate | date:'MM/dd/yyyy') || '-' }}</span>
            <i 
              *ngIf="code.hasDifferentEffectiveDate" 
              class="pi pi-info-circle"
              pTooltip="This code has modifiers with different dates."
              tooltipPosition="bottom"
              role="img"
              aria-label="This code has modifiers with different dates">
            </i>
          </div>
        </td>
        <td>{{ (code.planEffectiveEndDate | date:'MM/dd/yyyy') || '-' }}</td>
        <td>{{ code.dmeposCategory }}</td>
        <td>{{ code.modifiers }}</td>
       <td class="text-right">
          <div class="flex items-center gap-2 justify-end">
            <span 
              class="forms-count"
              [pTooltip]="code.formDetails && code.formDetails.length > 0 ? getFormsTooltip(code) : ''"
              tooltipPosition="bottom"
              [escape]="true"
              [style.cursor]="code.formDetails && code.formDetails.length > 0 ? 'pointer' : 'default'">
              {{ code.forms }}
            </span>
          </div>
        </td>
        <td class="text-center">
          <button 
            pButton  
            type="button"
            icon="pi pi-trash" 
            class="p-button-text p-button-danger p-button-sm"
            (click)="onDeleteCode(code)"
            pTooltip="Delete Code"
            tooltipPosition="left"
            [attr.aria-label]="'Delete code ' + code.code">
          </button>
        </td>
      </tr>
    </ng-template>

    <ng-template #expandedrow let-code>
      <tr class="surface-0">
        <td colspan="9" class="p-0 border-none">
          <app-code-expanded-view [code]="code" [filters]="filters"></app-code-expanded-view>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9" class="text-left">
          <p class="text-color-secondary m-0 italic">
            {{ filters ? 'No records found.' : 'No Data available. Please, select Program, Tenant, and Plan to view results.' }}
          </p>
        </td>
      </tr>
    </ng-template>
  </p-table>

<!-- Confirmation Dialog -->
<p-confirmDialog styleClass="confirm-dialog"></p-confirmDialog>

<!-- Toast Messages -->
<p-toast position="bottom-left"></p-toast>
